import { gql } from "@apollo/client";

export const UpdateSystem = gql`
    mutation UpdateSystem($systemId: ID!, $input: SystemUpdateAttributesInput!) {
        updateSystem(systemId: $systemId, input: $input) {
            id
        }
    }
`;
